import { useNewNavigation } from "@/hooks/useNewNavigation";
import React from "react";
import { Navigate } from "react-router-dom";

type RouteLegacyNavigationOnlyProps = {
  element: React.ReactElement;
};

/**
 * Keeps a route reachable only for teams still on the legacy navigation.
 *
 * Hiding the menu entry is not enough: users trained for weeks have the
 * prospecting page bookmarked, and the route answers to anyone typing it.
 *
 * The redirect is declarative rather than an effect: `teamSelected` changes
 * when the user switches team from the header, and a `<Navigate>` evaluated on
 * every render bounces them out of a page their new team no longer has. An
 * effect running once on mount would leave them stranded on it.
 */
export const RouteLegacyNavigationOnly: React.FC<
  RouteLegacyNavigationOnlyProps
> = ({ element }) => {
  const { isNewNavigationEnabled } = useNewNavigation();

  if (isNewNavigationEnabled) {
    return <Navigate to="/chat" replace />;
  }

  return element;
};
